import { INhomLoaiThuChiReducer } from "../../reducer-model/category/INhomLoaiThuChiReducer";
import { IDmNhomLoaiThuChiActionTypes } from "../../action-types/category/IDmNhomLoaiThuChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: INhomLoaiThuChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  nhomLoaiThuChis: [],
};
export const nhomLoaiThuChiReducer = (
  state: INhomLoaiThuChiReducer = iniState,
  action: IDmNhomLoaiThuChiActionTypes
): INhomLoaiThuChiReducer => {
  switch (action.type) {
    case "NHOM_LOAI_THU_CHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NHOM_LOAI_THU_CHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        nhomLoaiThuChis: action.payload,
      };
    case "NHOM_LOAI_THU_CHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_LOAI_THU_CHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NHOM_LOAI_THU_CHI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NHOM_LOAI_THU_CHI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_LOAI_THU_CHI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NHOM_LOAI_THU_CHI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "NHOM_LOAI_THU_CHI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NHOM_LOAI_THU_CHI_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        nhomLoaiThuChiEditing: action.payload,
      };
    case "NHOM_LOAI_THU_CHI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        nhomLoaiThuChiEditing: undefined,
      };
    default:
      return state;
  }
};
